import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import IconButton from '@material-ui/core/IconButton';
import Utils from './Utils';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    margin: {
        width: '220px',
        textTransform: 'none',
        textAlign: 'left',
      },

  }));
  

  
/**
 * data ve více sloupcích
 */
export default function DetailTable(props) {
    
/**
   * 
   * odstraní člověka do rezervace
   *  
   */
  function  handleClick(myId ) {
    console.log('Klik:',myId );

    var formData = new FormData();
      formData.append('rejectReservation', true);
      formData.append('ReservationId', myId );
      
      let fetchData = { 
        method: 'POST', body: formData,      
        headers: {
           headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        },  
      }

    // A posílám
    fetch(Utils.getURL(), fetchData)   
    .then(response => response.json())
    .then(data => {          
        if ( data["success"]) {
        // console.log('Stav:', "OK");  
        // zrefreshuji
        props.onRefresh();
      }
        else{
              }            
    })
    .catch((error) => {
      console.error('Chyba:', error);
    });

  }   

        const classes = useStyles();    
        return (
            <div>
                <div className={classes.root}>
                 {props.myData.map((item, index) =>
                     <Button className={classes.margin} variant="contained" >
                        {"Číslo:" + item.res_id }
                        <br></br>       
                        {"Jméno:" + item.res_name }
                 <br></br>{"(Osob:"+ item.res_count + ")"}
                 
                      <IconButton color="secondary" variant="contained" 
                        onClick={() => handleClick(item.res_id )}
                        >
                          <IndeterminateCheckBoxIcon fontSize="large" ></IndeterminateCheckBoxIcon>
                      </IconButton>
                     </Button>
                    )
                    }
                </div>
            </div>
        )
    }

